module.exports = __webpack_public_path__ + "static/media/about-6.743e64df.jpg";